export const getFileNameFromPath = (path?: string) => {
  try {
    if (path && path.includes('http')) {
      return new URL(path).pathname.slice(1);
    }
    return path || '';
  } catch {
    // for debugging
    console.error("Invalid file URL:", path);
    return path || '';
  }
};
